
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subset",
      function () {
        return require("private-next-pages/subset.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subset"])
      });
    }
  